import React, { useEffect, useState } from "react";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface InteractionsStaleTableState {
  data: any;
}

export const InteractionsStaleTable = ({ data }: InteractionsStaleTableState): React.JSX.Element | null => {
  const [tableData, setTableData] = useState<any[]>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Name", key: "creator_name" },
    { label: "Most Recent Interaction", key: "most_recent_date_only" },
  ];

  useEffect(() => {
    if (data) {
      const { notes } = data;
      setTableData(notes?.stale_cases || []);
    } else {
      setTableData([]);
    }
  }, [data]);

  return tableData ? (
    <DataTable tableHeadings={tableHeaders} tableData={tableData} title={"Cases with No Interactions in Past Week"} />
  ) : (
    loadingCard()
  );
};
